module.exports = __webpack_public_path__ + "static/media/aws-logo.18c6c43b.svg";